import type { ProductReviewsResponse } from '~/interfaces/product';

export const fetchProductReviews = async (
  productSlug: string,
  page = 1,
  perPage?: number,
): Promise<ProductReviewsResponse | null> => {
  const params = new URLSearchParams({ slug: productSlug, page: String(page) });
  if (perPage) {
    params.set('per_page', String(perPage));
  }

  const response = await fetch(`/product_reviews?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Sec-Fetch-Dest': 'empty',
    },
  });

  if (response.ok) {
    return response.json();
  }

  return null;
};
